import {
  PawIcon,
  MotorcycleIcon,
  CarIcon,
  BoatIcon,
  FurnitureIcon,
  HomeIcon,
  TractorIcon,
  FreightIcon,
  BoxIcon,
} from "@/components/svgs"

export const shippingOptions = [
  {
    value: "animals",
    label: "Pets and animals",
    icon: <PawIcon />,
  },
  {
    value: "motorcycles",
    label: "Motorcycles",
    icon: <MotorcycleIcon />,
  },
  {
    value: "vehicles",
    label: "Vehicles",
    icon: <CarIcon />,
  },
  {
    value: "boats",
    label: "Boats and water vehicles",
    icon: <BoatIcon />,
  },
  {
    value: "household-items",
    label: "Household items",
    icon: <FurnitureIcon />,
  },
  {
    value: "apartment-home-moves",
    label: "Apartment and home moves",
    icon: <HomeIcon />,
  },
  {
    value: "heavy-equipment",
    label: "Heavy equipment and industrial",
    icon: <TractorIcon />,
  },
  {
    value: "freight",
    label: "Freight",
    icon: <FreightIcon />,
  },
  {
    value: "others",
    label: "All other items",
    icon: <BoxIcon />,
  },
]
